import { useState } from "react";
import { Button } from "@mui/material";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import { candidateRequests } from "api/candidateApi";
import { CANDIDACIES_REGULAR } from "utils/constants";
import dataProvider from "server/dataProvider";
import { useNotifyError } from "utils/useNotifyError";

const CandidaciesDialog = ({ userId }) => {
  const [candidacies, setCandidacies] = useState(null);
  const notifyError = useNotifyError();

  const getCandidates = async () => {
    try {
      const res = await dataProvider.customRequest(candidateRequests.getUserCandidacies(userId));
      setCandidacies(res?.data);
    } catch (error) {
      notifyError(error);
      return false;
    }
  };

  return (
    <ConfirmModal
      isConfirmButton={false}
      titleContent={"Кандидатури"}
      onOpen={getCandidates}
      triggerButton={
        <Button
          label="Виж кандидатури"
          startIcon={<PersonSearchIcon />}
          variant="contained"
          size="medium"
          color="primary"
        >
          Виж кандидатури
        </Button>
      }
    >
      {candidacies?.map((candidacy, idx) => (
        <a
          href={`/${candidateRequests.candidaciesBySubType(CANDIDACIES_REGULAR)}/${candidacy.candidacyId}/show`}
          key={idx}
          style={{ display: "block", marginBottom: "1rem" }}
        >
          {candidacy?.campaignNameBg} ({candidacy?.candidacyStateTextBg})
        </a>
      ))}
    </ConfirmModal>
  );
};

export default CandidaciesDialog;
